import React, { useEffect, useState } from 'react'

import { api } from '../../../../../../../../../services'
import {
  Modal,
  Spin,
  Button,
  Card,
  Typography,
  Space,
  Divider,
  Icon
} from 'antd'
import { useSelector } from 'react-redux'

import StoryCreationForm from './StoryCreationForm'
import './styles.scss'
import { useTranslation } from 'react-i18next'

const { Text, Paragraph } = Typography

const Story = props => {
  const { courseId, onCancel } = props
  const [isLoading, setIsLoading] = useState(false)
  const [storyItems, setStoryItems] = useState([])
  const [showStoryCreationForm, setShowStoryCreationForm] = useState(false)
  const [isContinuingStory, setIsContinuingStory] = useState(false)
  const [selectedStory, setSelectedStory] = useState(null)
  const [continuedStory, setContinuedStory] = useState(null)

  console.log('storyItems', props)
  const { t } = useTranslation()

  useEffect(() => {
    fetchStory()
  }, [])

  const user = useSelector(state => state.user)

  const fetchStory = async () => {
    try {
      setIsLoading(true)
      const res = await api.courses.getStory({
        orgId: user?.info?.active_organization_id,
        courseId: courseId
      })

      setStoryItems(res?.data?.items || [])
    } catch (error) {
      console.log(error)
    } finally {
      setIsLoading(false)
    }
  }

  const toPlainText = html => {
    const div = document.createElement('div')
    div.innerHTML = String(html)
    const text = div.textContent || div.innerText || ''
    return text.trim()
  }

  const handleContinueStory = storyItem => {
    Modal.confirm({
      title: t('v4:continue_this_story_question'),
      content: (
        <div>
          <p>
            {t('v4:this_will_generate_a_continuation_of_the_seleccted_story')}
          </p>
          <p>
            <strong>{t('v4:what_will_happen')}</strong>
          </p>
          <ul style={{ marginTop: '8px', paddingLeft: '20px' }}>
            <li>{t('v4:the_ai_will_analyze_the_existing_story_content')}</li>
            <li>
              {t(
                'v4:generate_a_natural_continuation_that_follows_the_same_tone'
              )}
            </li>
            <li>
              {t('v4:create_new_content_that_build_upon_the_current_narrative')}
            </li>
          </ul>
          <p style={{ marginTop: '12px', color: '#666', fontSize: '12px' }}>
            <strong>{t('v4:note')}</strong>{' '}
            {t('v4:this_process_may_take_a_few_moments_to_complete')}
          </p>
        </div>
      ),
      okText: 'Yes, Continue Story',
      cancelText: t('v4:cancel'),
      okType: 'primary',
      centered: true,
      width: 500,
      onOk: async () => {
        try {
          setIsContinuingStory(true)
          const courseContent = toPlainText(storyItem?.params?.course_content)
          const payload = {
            previous_story: storyItem.story,
            course_content: courseContent,
            story_elements: storyItem?.params?.story_elements,
            language: props?.language,
            is_continuation: true
          }

          const res = await api.courses.continueStory(payload)
          // Handle the response - you might want to show the continued story
          console.log('Continued story:', res.data)
          const storyString = res && res.data ? res.data : ''
          setContinuedStory(storyString)
          setShowStoryCreationForm(true)

          // Show success message
        } catch (error) {
          console.log('Error continuing story:', error)
        } finally {
          setIsContinuingStory(false)
        }
      }
    })
  }

  const handleCreateNewStory = () => {
    setShowStoryCreationForm(true)
  }

  const handleStoryCreationCancel = () => {
    setShowStoryCreationForm(false)
    setContinuedStory(null)
  }

  const renderStoryItems = () => {
    if (storyItems.length === 0) {
      return (
        <div className="story-empty-state">
          <div className="empty-message">
            <Text type="secondary">
              {t('v4:no_existing_stories_found_for_this_course')}
            </Text>
          </div>
          <Button
            type="primary"
            size="large"
            className="create-first-btn"
            onClick={handleCreateNewStory}
          >
            {t('v4:create_your_first_story')}
          </Button>
        </div>
      )
    }

    return (
      <div className="story-items-container">
        <div className="story-header">
          <Text className="story-count">
            {t('v4:existing_stories')} ({storyItems.length})
          </Text>
          <Button
            type="default"
            className="create-new-btn"
            onClick={handleCreateNewStory}
          >
            + {t('v4:create_new_story')}
          </Button>
        </div>

        {storyItems.map((storyItem, index) => (
          <Card
            key={index}
            size="small"
            style={{ marginBottom: '16px' }}
            title={
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center'
                }}
              >
                <Text strong>Story {index + 1}</Text>
                <Text
                  type="secondary"
                  style={{ fontSize: '12px', fontWeight: 'normal' }}
                >
                  {storyItem.created_at
                    ? new Date(storyItem.created_at).toLocaleDateString()
                    : ''}
                </Text>
              </div>
            }
          >
            <div className="story-preview">
              <Paragraph
                ellipsis={{
                  rows: 3,
                  expandable: true,
                  symbol: expanded => (expanded ? 'Show less' : 'Read more')
                }}
                style={{ marginBottom: '16px', lineHeight: '1.6' }}
              >
                {storyItem.story}
              </Paragraph>
            </div>

            {storyItem.params &&
              storyItem.params.story_elements &&
              (() => {
                try {
                  const storyElements = JSON.parse(
                    storyItem.params.story_elements
                  )
                  return (
                    <div
                      style={{
                        marginBottom: '16px',
                        padding: '8px 12px',
                        backgroundColor: '#f8f9fa',
                        borderRadius: '6px',
                        border: '1px solid #e9ecef'
                      }}
                    >
                      <Text type="secondary" style={{ fontSize: '12px' }}>
                        <strong>{t('v4:tone')}:</strong> {storyElements.tone} •
                        <strong> {t('v4:style')}:</strong>{' '}
                        {storyElements.narrativeStyle} •
                        <strong> {t('v4:genre')}:</strong> {storyElements.genre}
                      </Text>
                    </div>
                  )
                } catch (error) {
                  console.log('Error parsing story elements:', error)
                  return null
                }
              })()}

            <div className="story-actions">
              <Button
                type="primary"
                size="small"
                loading={isContinuingStory}
                onClick={() => handleContinueStory(storyItem)}
                style={{ marginRight: '8px', padding: '4px 12px' }}
              >
                {t('v4:continue_this_story')}
                <Icon type="right" />
              </Button>
            </div>
          </Card>
        ))}
      </div>
    )
  }

  if (showStoryCreationForm) {
    return (
      <StoryCreationForm
        onCancel={handleStoryCreationCancel}
        initialStory={continuedStory}
        {...props}
      />
    )
  }

  return (
    <Modal
      title={t('v5:choose_your_story')}
      visible
      onCancel={onCancel}
      footer={null}
      width={700}
      centered
      className="story-selection-modal"
    >
      {isLoading ? (
        <div
          style={{
            textAlign: 'center',
            padding: '60px 20px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '16px'
          }}
        >
          <Spin size="large" />
          <Text type="secondary">{t('v4:loading_your_stories')}</Text>
        </div>
      ) : (
        renderStoryItems()
      )}
    </Modal>
  )
}

export default Story
